import { grey } from "@mui/material/colors";

const styles = {
  message: {
    px: 2,
    py: 1,
    border: `1px solid`,
    borderColor: grey[300],
    borderRadius: 2,
    m: 1,
  },
  assistantMessage: {
    backgroundColor: "white",
  },
  userMessage: {
    backgroundColor: "rgba(128,132,255,0.18)",
    borderColor: "rgba(128,132,255,0.35)",
  },
  iconButton: {
    fontSize: 12,
    textTransform: "none",
    backgroundColor: "#8084FF",
    color: "white",
    "&:hover": { backgroundColor: "#6970E8" },
  },
  text: {
    overflow: "hidden",
    maxWidth: "300px",
    textOverflow: "ellipsis",
    "& p:empty::after": {
      content: '"\\00A0"',
    },
    "& p:has(br:last-child)::after": {
      content: '"\\00A0"',
    },
    "& p": {
      m: 0,
    },
    my: 0.5,
  },
};

export default styles;
